export const HEATMAP_COLORS = {
  bottom: {
    light: {
      text: 'text-white',
      background: 'bg-[var(--red-500)]',
      hover: 'hover:bg-[var(--red-600)]',
      rawColorVar: 'var(--red-500)',
      rawTextColor: 'white',
    },
    dark: {
      text: 'text-white',
      background: 'bg-[var(--red-200)]',
      hover: 'hover:bg-[var(--red-300)]',
      rawColorVar: 'var(--red-200)',
      rawTextColor: 'white',
    },
  },
  level1: {
    light: {
      text: 'text-white',
      background: 'bg-[var(--red-400)]',
      hover: 'hover:bg-[var(--red-500)]',
      rawColorVar: 'var(--red-400)',
      rawTextColor: 'white',
    },
    dark: {
      text: 'text-white',
      background: 'bg-[var(--red-100)]',
      hover: 'hover:bg-[var(--red-200)]',
      rawColorVar: 'var(--red-100)',
      rawTextColor: 'white',
    },
  },
  level2: {
    light: {
      text: 'text-black',
      background: 'bg-[var(--red-300)]',
      hover: 'hover:bg-[var(--red-400)]',
      rawColorVar: 'var(--red-300)',
      rawTextColor: 'black',
    },
    dark: {
      text: 'text-white',
      background: 'bg-[var(--red-50)]',
      hover: 'hover:bg-[var(--red-100)]',
      rawColorVar: 'var(--red-50)',
      rawTextColor: 'white',
    },
  },
  level3: {
    light: {
      text: 'text-black',
      background: 'bg-[var(--red-200)]',
      hover: 'hover:bg-[var(--red-300)]',
      rawColorVar: 'var(--red-200)',
      rawTextColor: 'black',
    },
    dark: {
      text: 'text-white',
      background: 'bg-[var(--red-25)]',
      hover: 'hover:bg-[var(--red-50)]',
      rawColorVar: 'var(--red-25)',
      rawTextColor: 'white',
    },
  },
  level4: {
    light: {
      text: 'text-black',
      background: 'bg-[var(--red-100)]',
      hover: 'hover:bg-[var(--red-200)]',
      rawColorVar: 'var(--red-100)',
      rawTextColor: 'black',
    },
    dark: {
      text: 'text-white',
      background: 'bg-[var(--red-25)]',
      hover: 'hover:bg-[var(--red-50)]',
      rawColorVar: 'var(--red-25)',
      rawTextColor: 'white',
    },
  },
  middle: {
    light: {
      text: 'text-black',
      background: 'bg-[var(--gray-100)]',
      hover: 'hover:bg-[var(--gray-200)]',
      rawColorVar: 'var(--gray-100)',
      rawTextColor: 'black',
    },
    dark: {
      text: 'text-white',
      background: 'bg-[var(--gray-200)]',
      hover: 'hover:bg-[var(--gray-300)]',
      rawColorVar: 'var(--gray-200)',
      rawTextColor: 'white',
    },
  },
  level6: {
    light: {
      text: 'text-black',
      background: 'bg-[var(--green-100)]',
      hover: 'hover:bg-[var(--green-200)]',
      rawColorVar: 'var(--green-100)',
      rawTextColor: 'black',
    },
    dark: {
      text: 'text-white',
      background: 'bg-[var(--green-25)]',
      hover: 'hover:bg-[var(--green-50)]',
      rawColorVar: 'var(--green-25)',
      rawTextColor: 'white',
    },
  },
  level7: {
    light: {
      text: 'text-black',
      background: 'bg-[var(--green-200)]',
      hover: 'hover:bg-[var(--green-300)]',
      rawColorVar: 'var(--green-200)',
      rawTextColor: 'black',
    },
    dark: {
      text: 'text-white',
      background: 'bg-[var(--green-50)]',
      hover: 'hover:bg-[var(--green-100)]',
      rawColorVar: 'var(--green-50)',
      rawTextColor: 'white',
    },
  },
  level8: {
    light: {
      text: 'text-black',
      background: 'bg-[var(--green-300)]',
      hover: 'hover:bg-[var(--green-400)]',
      rawColorVar: 'var(--green-300)',
      rawTextColor: 'black',
    },
    dark: {
      text: 'text-white',
      background: 'bg-[var(--green-100)]',
      hover: 'hover:bg-[var(--green-200)]',
      rawColorVar: 'var(--green-100)',
      rawTextColor: 'white',
    },
  },
  level9: {
    light: {
      text: 'text-white',
      background: 'bg-[var(--green-400)]',
      hover: 'hover:bg-[var(--green-500)]',
      rawColorVar: 'var(--green-400)',
      rawTextColor: 'white',
    },
    dark: {
      text: 'text-white',
      background: 'bg-[var(--green-200)]',
      hover: 'hover:bg-[var(--green-300)]',
      rawColorVar: 'var(--green-200)',
      rawTextColor: 'white',
    },
  },
  top: {
    light: {
      text: 'text-white',
      background: 'bg-[var(--green-500)]',
      hover: 'hover:bg-[var(--green-600)]',
      rawColorVar: 'var(--green-500)',
      rawTextColor: 'white',
    },
    dark: {
      text: 'text-white',
      background: 'bg-[var(--green-300)]',
      hover: 'hover:bg-[var(--green-400)]',
      rawColorVar: 'var(--green-300)',
      rawTextColor: 'white',
    },
  },
};

export const getHeatmapStyleFromPercentageLegacy = ({
  colorMode,
  min,
  max,
  score,
  isLowerBetter,
}: {
  colorMode: 'light' | 'dark';
  min?: number;
  max?: number;
  score?: number | null;
  isLowerBetter?: boolean;
}): {
  text: string;
  background: string;
  hover: string;
  rawColorVar: string;
  rawTextColor: string;
} => {
  if (min == null || max == null || score == null) {
    return HEATMAP_COLORS.bottom[colorMode];
  }

  let minimum = min;
  let maximum = max;
  if (min >= 0) {
    minimum = 0;
  }
  if (max >= 0 && max <= 1) {
    maximum = 1;
  } else if (max <= 0) {
    maximum = 0;
  }

  let percentage = Number(((score - minimum) / (maximum - minimum)).toFixed(2));
  if (isLowerBetter) {
    percentage = 1 - percentage;
  }
  if (percentage == 0) {
    return HEATMAP_COLORS.bottom[colorMode];
  } else if (percentage < 0.5) {
    return HEATMAP_COLORS.level1[colorMode];
  } else if (percentage == 0.5) {
    return HEATMAP_COLORS.middle[colorMode];
  } else if (percentage < 1) {
    return HEATMAP_COLORS.level8[colorMode];
  } else if (percentage == 1) {
    return HEATMAP_COLORS.top[colorMode];
  } else {
    return {
      text: '',
      background: '',
      hover: '',
      rawColorVar: '',
      rawTextColor: '',
    };
  }
};

export const getHeatmapStyleFromPercentage = ({
  colorMode,
  min,
  max,
  colorGradient,
  score,
  isLowerBetter,
}: {
  colorMode: 'light' | 'dark';
  min?: number;
  max?: number;
  colorGradient?: [number, string][];
  score?: number | null;
  isLowerBetter?: boolean;
}): {
  text: string;
  background: string;
  hover: string;
  rawColorVar: string;
  rawTextColor: string;
} => {
  if (score == null) {
    return HEATMAP_COLORS.bottom[colorMode];
  }

  // If no colorGradient provided, use legacy function
  if (colorGradient == null || colorGradient.length === 0) {
    return getHeatmapStyleFromPercentageLegacy({
      colorMode,
      min,
      max,
      score,
      isLowerBetter,
    });
  }

  // Use colorGradient for min, max, and mid values
  const minimum = colorGradient[0][0];
  const maximum = colorGradient[colorGradient.length - 1][0];
  const mid = colorGradient[1]?.[0];

  // Handle case where mid is not defined or gradient is malformed
  if (
    mid == null ||
    minimum == null ||
    maximum == null ||
    maximum === minimum
  ) {
    return HEATMAP_COLORS.bottom[colorMode];
  }

  // Calculate the midpoint - use provided mid or default to halfway between min and max
  const defaultMid = (minimum + maximum) / 2;
  const midpoint =
    mid != null
      ? (mid - minimum) / (maximum - minimum)
      : (defaultMid - minimum) / (maximum - minimum);

  // Calculate percentage relative to the gradient stops
  let percentage: number;

  if (score <= mid) {
    // Score is between minimum and midpoint
    const localPercentage =
      mid === minimum ? 0 : (score - minimum) / (mid - minimum);
    if (isLowerBetter) {
      // In lower-is-better mode, lower scores should map to higher percentages
      percentage = midpoint + (1 - localPercentage) * (1 - midpoint);
    } else {
      // In higher-is-better mode, lower scores should map to lower percentages
      percentage = localPercentage * midpoint;
    }
  } else {
    // Score is between midpoint and maximum
    const localPercentage =
      maximum === mid ? 1 : (score - mid) / (maximum - mid);
    if (isLowerBetter) {
      // In lower-is-better mode, higher scores should map to lower percentages
      percentage = (1 - localPercentage) * midpoint;
    } else {
      // In higher-is-better mode, higher scores should map to higher percentages
      percentage = midpoint + localPercentage * (1 - midpoint);
    }
  }

  if (isNaN(percentage)) {
    return {
      text: '',
      background: '',
      hover: '',
      rawColorVar: '',
      rawTextColor: '',
    };
  }

  // Use 11 levels with distribution that accounts for the actual midpoint position
  const adjustedMidpoint = midpoint;

  // Create 11 levels: 5 below midpoint, 1 at midpoint, 5 above midpoint
  const belowMidThresholds = [
    adjustedMidpoint * 0.2,
    adjustedMidpoint * 0.4,
    adjustedMidpoint * 0.6,
    adjustedMidpoint * 0.8,
  ];

  const aboveMidThresholds = [
    adjustedMidpoint + (1 - adjustedMidpoint) * 0.2,
    adjustedMidpoint + (1 - adjustedMidpoint) * 0.4,
    adjustedMidpoint + (1 - adjustedMidpoint) * 0.6,
    adjustedMidpoint + (1 - adjustedMidpoint) * 0.8,
  ];

  if (percentage <= 0) {
    return HEATMAP_COLORS.bottom[colorMode];
  } else if (percentage <= belowMidThresholds[0]) {
    return HEATMAP_COLORS.level1[colorMode];
  } else if (percentage <= belowMidThresholds[1]) {
    return HEATMAP_COLORS.level2[colorMode];
  } else if (percentage <= belowMidThresholds[2]) {
    return HEATMAP_COLORS.level3[colorMode];
  } else if (percentage <= belowMidThresholds[3]) {
    return HEATMAP_COLORS.level4[colorMode];
  } else if (percentage < aboveMidThresholds[0]) {
    // Middle takes everything between the thresholds
    return HEATMAP_COLORS.middle[colorMode];
  } else if (percentage <= aboveMidThresholds[1]) {
    return HEATMAP_COLORS.level6[colorMode];
  } else if (percentage <= aboveMidThresholds[2]) {
    return HEATMAP_COLORS.level7[colorMode];
  } else if (percentage <= aboveMidThresholds[3]) {
    return HEATMAP_COLORS.level8[colorMode];
  } else if (percentage < 1) {
    return HEATMAP_COLORS.level9[colorMode];
  } else {
    return HEATMAP_COLORS.top[colorMode];
  }
};
